import { cn } from '@ordo/ui/cn'
import { Tabs, TabsList, TabsTrigger } from '@ordo/ui/tabs'
import type { ReactElement } from 'react'

// Underline tab styling (per Figma) — override @ordo/ui/tabs' default
// segmented-pill look: a left-aligned row with a baseline border, and the
// active trigger marked by a foreground underline rather than a filled pill.
const TABS_LIST_CLASS = 'h-auto w-full justify-start gap-1 rounded-none border-b border-border bg-transparent p-0'
const TABS_TRIGGER_CLASS =
  'relative -mb-px rounded-none border-b-2 border-transparent bg-transparent px-4 pb-2.5 pt-2.5 text-muted-foreground shadow-none data-[state=active]:border-foreground data-[state=active]:bg-transparent data-[state=active]:text-foreground data-[state=active]:shadow-none lg:pt-1'

/** Shared, horizontally scrollable campus selector for order and service history. */
export function SchoolCampusTabs({
  schools,
  value,
  onValueChange,
}: {
  schools: readonly { id: string; name: string }[]
  value: string
  onValueChange: (locationId: string) => void
}): ReactElement | null {
  if (schools.length < 2) {
    return null
  }
  return (
    <div className="shrink-0 overflow-x-auto">
      <Tabs value={value} onValueChange={onValueChange}>
        <TabsList aria-label="Campuses" className={cn(TABS_LIST_CLASS, 'w-max min-w-full')}>
          {schools.map((school) => (
            <TabsTrigger key={school.id} value={school.id} className={cn(TABS_TRIGGER_CLASS, 'whitespace-nowrap')}>
              {school.name}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
    </div>
  )
}
